export default "__VITE_ASSET__D6ToI6PF__"